<template>
      <ul>
        <label-value-item
            v-for="(attribute,index) in attributes"
            :key="attribute.code"
            :label-value="constructLabelValueItem(attribute)"
            :with-drawing-code="withDrawingCode"
            v-if="limit===0 || (limit!==0 && index<limit)"
        />
      </ul>
</template>

<script>
//@todo limitation des attributes ?
import LabelValueItem from "@/components/LabelValue/LabelValueItem.vue"
import {mapState} from "vuex";

export default {
  name: "SheetBlockFeaturesList",
  components: {
    LabelValueItem,
  },
  props: {
    attributes: {
      type: Array,
      required: true,
      default: null
    },
    withDrawingCode: {
      type: Boolean,
      required : false,
      default : false
    },
    limit : {
      type : Number,
      default:0,
      required: false
    }
  },
  computed: {
    ...mapState({
      unitType: state => state.settings.unitType
    }),
  },
  methods: {
    constructLabelValueItem(attribute) {
      return {
        label: attribute.label,
        value: attribute.value.display[this.unitType],
        drawingCode: attribute.nomenclature,
      }
    },
  }
}
</script>

<style scoped>

</style>
